import CryptoJS from "crypto-js";

export const HOSTNAME = process.env.REACT_APP_HOSTNAME;
export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const PORTAL_URL = process.env.REACT_APP_PORTAL_URL;
export const WDB_WEB_URL = process.env.REACT_APP_WDB_WEB_URL;
export const PLATFORM_API_URL = process.env.REACT_APP_PLATFORM_API_URL;
export const API_KEY = process.env.REACT_APP_API_KEY;
export const GA_TRACKING_ID = process.env.REACT_APP_GA_TRACKING_ID;
export const SAMSUNG_EVENT_PARTNER_UUID = process.env.REACT_APP_SAMSUNG_EVENT_PARTNER_UUID;
export const SAMSUNG_EVENT_WEGAZINE_UUID = process.env.REACT_APP_SAMSUNG_EVENT_WEGAZINE_UUID;
export const APELGAMO_URL = process.env.REACT_APP_APELGAMO_URL;
export const CHAPEL_URL = process.env.REACT_APP_CHAPEL_URL;
export const LUVEL_URL = process.env.REACT_APP_LUVEL_URL;
export const KAKAO_LOGIN_APP_KEY = process.env.REACT_APP_KAKAO_LOGIN_APP_KEY;
export const NAVER_LOGIN_APP_KEY = process.env.REACT_APP_NAVER_LOGIN_APP_KEY;
export const APPLE_LOGIN_APP_KEY = process.env.REACT_APP_APPLE_LOGIN_APP_KEY;
export const LOGIN_REDIRECT_URI = process.env.REACT_APP_LOGIN_REDIRECT_URL;
export const ENCRYPTION_KEY = process.env.REACT_APP_ENCRYPTION_KEY;
export const REACT_APP_ENV = process.env.REACT_APP_ENV;
export const REGISTRY_URL = process.env.REACT_APP_REGISTRY_URL;
export const REGISTRY_API_URL = process.env.REACT_APP_REGISTRY_API_URL;
export const REGISTRY_IMAGE_URL = process.env.REACT_APP_REGISTRY_IMAGE_URL;
/** S3 등 상품 이미지 베이스 (weddingbook-web-next REGISTRY_STORAGE_URL 과 동일 용도) */
export const REGISTRY_STORAGE_URL = REGISTRY_IMAGE_URL || "";
export const REGISTRY_CART_URL = process.env.REACT_APP_REGISTRY_CART_URL;
export const KAKAO_SDK_INTEGRITY = process.env.REACT_APP_KAKAO_SDK_INTEGRITY;
export const KAKAO_SDK_APP_KEY = process.env.REACT_APP_KAKAO_SDK_APP_KEY;
export const SOCIAL_LOGIN_MAP = process.env.REACT_APP_SOCIAL_LOGIN_MAP;

export const isApp = () => {};
export const isMobile = () => {
  const toMatch = [
    /Android/i,
    /webOS/i,
    /iPhone/i,
    /iPad/i,
    /iPod/i,
    /BlackBerry/i,
    /Windows Phone/i,
  ];
  return toMatch.some((toMatchItem) => {
    return navigator.userAgent.match(toMatchItem);
  });
};
export const getOs = (): "ios" | "android" | "unknown" => {
  let userAgent = window.navigator.userAgent,
    platform = window.navigator.platform,
    iosPlatforms = ["iPhone", "iPad", "iPod"];
  let os: "ios" | "android" | "unknown" = "unknown";

  if (iosPlatforms.indexOf(platform) !== -1) {
    os = "ios";
  } else if (/Android/.test(userAgent)) {
    os = "android";
  }

  return os;
};
export const getOsByApp = () => {
  if (window.hasOwnProperty("wb_bridge")) {
    return "android";
  }
  if (window.hasOwnProperty("webkiet")) {
    return "ios";
  }
  return "unknown";
};
export const isWebview = () => {
  if (window.hasOwnProperty("wb_bridge") || window.hasOwnProperty("webkit")) {
    return true;
  }
  return false;
};
export const isExternalUrl = (url: string) => {
  if (!url) return "";
  if (url.indexOf("h2mwbell://") >= 0) {
    return url;
  }
  let checkUrl = "";
  const hasSubdomainPattern = /^[a-zA-Z0-9-]+\.[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/i.test(url);
  if (hasSubdomainPattern) {
    checkUrl = "https://" + url;
  } else {
    // 상대주소 일때 호스트네임 붙임
    const parsedUrl = new URL(url, "http://checkhashostname.com"); // relative URL은 호스트네임으로 파싱되지 않음
    if (parsedUrl.hostname === "checkhashostname.com") {
      // 상대주소일 때 hostname 붙임
      checkUrl = HOSTNAME + url;
    }
  }
  let result = `h2mwbell://webview?url=${checkUrl || url}`;
  if (
    (url.indexOf(window.location.host) !== -1 || url.indexOf(REGISTRY_URL) !== -1) &&
    url.indexOf("hidetop") === -1
  ) {
    result += url.indexOf("?") === -1 ? "?" : "&";
    result += "hidetop=true";
  }
  return result;
};
export const addComma = (x: any) => {
  return x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0;
};
export const numberToKorean = (num: number | string) => {
  if (num === 0) {
    return "0원";
  }
  num = +num;
  const units = ["", "만", "억", "조", "경"];
  const splitUnit = 10000;
  const resultArray = [];
  let resultString = "";

  for (let i = 0; i < units.length; i++) {
    const unitResult = Math.floor((num % Math.pow(splitUnit, i + 1)) / Math.pow(splitUnit, i));
    if (unitResult > 0) {
      resultArray[i] = unitResult;
    }
  }

  for (let i = resultArray.length - 1; i >= 0; i--) {
    if (resultArray[i]) {
      resultString += `${addComma(resultArray[i])}${units[i]}`;
    }
  }

  return resultString + "원";
};
export const convertStringToInteger = (value: string | number) => {
  const result = String(value).replace(/[^0-9]/g, "");
  const number = parseInt(result);
  return isNaN(number) === false ? number : 0;
};

export const getWidthUnit = (width: string | number) => {
  if (width.toString().includes("px") || width.toString().includes("%")) {
    return width;
  }
  return width + "px";
};

export const autoHypenPhone = (str: string) => {
  // input bind keyup event
  // 핸드폰 번호 자동으로 하이픈 처리
  if (str.trim() === "" || typeof str !== "string") return "";
  str = str.replace(/[^0-9]/g, "");
  var tmp = "";
  if (str.length < 4) {
    return str;
  } else if (str.length < 7) {
    tmp += str.substring(0, 3);
    tmp += "-";
    tmp += str.substring(3, 99);
    return tmp;
  } else if (str.length < 11) {
    tmp += str.substring(0, 3);
    tmp += "-";
    tmp += str.substring(3, 6);
    tmp += "-";
    tmp += str.substring(6, 99);
    return tmp;
  } else {
    tmp += str.substring(0, 3);
    tmp += "-";
    tmp += str.substring(3, 7);
    tmp += "-";
    tmp += str.substring(7, 99);
    return tmp;
  }
};

export const chkPhoneTel = (str: string, type?: "PHONE" | "TEL" | "ETC") => {
  // 핸드폰 형식 정규식
  var reg = /^(01[016789]{1}|070|02|0[3-9]{1}[0-9]{1})-[0-9]{3,4}-[0-9]{4}$/;

  //앱에서는 핸드폰 번호 형태만 수집하고 있다고 하던데.. 혹시 모르니 type을 추가하여 010-1234-1234 형태만 검증
  if (type) {
    switch (type) {
      case "PHONE":
        const regP = /^010-[0-9]{4}-[0-9]{4}$/;
        return regP.test(str);
      // case "TEL":
      // case "ETC":
    }
  }
  return reg.test(str);
};

export const chkEmail = (str: string) => {
  // 이메일 형식 정규식
  const reg =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,})$/;
  return reg.test(str);
};

export const chkPassword = (str: string) => {
  // 비밀번호 형식 정규식
  // const reg = /^(?=.*[a-zA-Z])(?=.*[0-9]).{6,}$/;
  // return reg.test(str);
  let result = { length: false, alpha: false, number: false };
  if (str.length >= 6) {
    result.length = true;
  }
  if (str.match(/[a-zA-Z]/g)) {
    result.alpha = true;
  }
  if (str.match(/[0-9]/g)) {
    result.number = true;
  }
  return result;
};

export const chkReferralCode = (str: string) => {
  // 추천인 코드 형식 정규식
  // const reg = /^(?=.*[0-9])(?=.*[A-Z])[0-9A-Z]{6}$/;
  const reg = /^(?=.*[A-Z])[A-Z0-9]{6}$/;
  return reg.test(str);
};

// array
export const makeArray = (n: number) => {
  const arr = [];
  for (let i = 0; i < n; i++) {
    arr.push(i);
  }
  return arr;
};
export const shuffle = (array: any[]) => {
  for (let i = array.length - 1; i > 0; i--) {
    let j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
};
export const randomPick = <T>(array: T[], n: number): T[] => {
  let counting = 0;
  const result: T[] = [];
  const randomIndexList = [];
  while (result.length < n) {
    counting++;
    if (counting > array.length) {
      break;
    }
    const randomIndex = Math.floor(Math.random() * array.length);
    if (randomIndexList.includes(randomIndex)) {
      // 중복 index가 걸렸으니 카운팅 안하기
      --counting;
      continue;
    }
    result.push(array[randomIndex]);
    randomIndexList.push(randomIndex);
  }
  return result;
};

// image url
export const getImageUrlWithMaxWidth = (url: string | null | undefined, maxWidth?: number) => {
  if (!url) return "";
  const w = maxWidth || 1200;
  if (url.includes("imgs-v3.h2m.io")) {
    return url;
  }
  return `https://imgs-v3.h2m.io?url=${url}&w=${w}`;
};

// wait for
export const waitFor = async (milliSeconds: number) => {
  return new Promise<undefined>((resolve) => {
    setTimeout(() => {
      resolve(undefined);
    }, milliSeconds);
  });
};

export const removeZeroWithSpace = (str: string) => {
  return str.replace(/\u200B/g, "");
};
export const appendHttpsToWebUrl = (url: string) => {
  // url이 falsy한 경우 그대로 반환
  if (!url) return url;

  // h2mwbell:// 스킴링크가 포함된 경우 그대로 반환
  if (url.indexOf("h2mwbell://") >= 0) {
    return url;
  }

  // http나 https로 시작하는 경우 그대로 반환
  if (url.startsWith("http://") || url.startsWith("https://")) {
    return url;
  }

  // 그 외의 경우 https를 붙여서 반환
  return `https://${url}`;
};

export const smoothScrollTo = (
  target: Window | HTMLElement,
  scrollTargetY: number,
  time?: {
    baseSpeed?: number;
    maxDuration?: number;
    minDuration?: number;
  },
) => {
  return new Promise((resolve) => {
    const startScrollTop = target instanceof Window ? window.scrollY : target?.scrollTop;
    const distance = scrollTargetY - startScrollTop; // 스크롤 이동 거리 계산

    const defaultDurationTime = {
      baseSpeed: 2000,
      maxDuration: 500,
      minDuration: 150,
    };
    const durationTime = time ? { ...defaultDurationTime, ...time } : defaultDurationTime;
    const baseSpeed = durationTime.baseSpeed;
    const maxDuration = durationTime.maxDuration;
    const minDuration = durationTime.minDuration;

    // 스크롤 거리 기반으로 애니메이션 시간 계산
    let duration = (Math.abs(distance) / baseSpeed) * 1000;
    duration = Math.max(minDuration, Math.min(duration, maxDuration)); // 최소, 최대 시간 제한

    const startTime = performance.now();
    function scrollAnimation(currentTime) {
      const timeElapsed = currentTime - startTime;
      const progress = Math.min(timeElapsed / duration, 1); // progress: 0에서 1까지

      // 스크롤 위치 계산 (progress에 따라 점점 목표 지점으로 이동)
      const scrollY =
        distance > 0
          ? Math.max(
              Math.min(
                Math.floor(startScrollTop + (scrollTargetY - startScrollTop) * progress),
                scrollTargetY,
              ),
              0,
            )
          : Math.min(
              Math.max(
                Math.floor(startScrollTop + (scrollTargetY - startScrollTop) * progress),
                scrollTargetY,
              ),
              startScrollTop,
            );
      target.scrollTo(0, scrollY);

      // 아직 애니메이션이 끝나지 않았다면 requestAnimationFrame으로 계속 호출
      if (progress < 1) {
        requestAnimationFrame(scrollAnimation);
      } else {
        // 애니메이션이 끝났을 때 Promise를 resolve하여 후속 처리를 할 수 있도록 함
        resolve(true);
      }
    }
    // 첫 번째 애니메이션 프레임 호출
    requestAnimationFrame(scrollAnimation);
  });
};
type TDiffParam = {
  [key: string]: unknown;
};
export const deepDiffMapper = (() => {
  return {
    VALUE_CREATED: "created",
    VALUE_UPDATED: "updated",
    VALUE_DELETED: "deleted",
    VALUE_UNCHANGED: "unchanged",
    map: function (obj1: TDiffParam, obj2: TDiffParam) {
      if (this.isFunction(obj1) || this.isFunction(obj2)) {
        throw new Error("Invalid argument. Function given, object expected.");
      }
      // 값이 원시타입일 경우 비교
      if (this.isValue(obj1) || this.isValue(obj2)) {
        return {
          type: this.compareValues(obj1, obj2),
          data: obj2,
          prevData: obj1,
        };
      }

      // 값이 참조 타입일 경우 재귀 호출을 이용하여 내부 비교
      var diff = {};
      for (const key in obj1) {
        if (this.isFunction(obj1[key])) {
          continue;
        }

        var value2 = undefined;
        if (obj2[key] !== undefined) {
          value2 = obj2[key];
        }
        diff[key] = this.map(obj1[key], value2);
      }
      for (const key in obj2) {
        if (this.isFunction(obj2[key]) || diff[key] !== undefined) {
          continue;
        }

        diff[key] = this.map(undefined, obj2[key]);
      }

      return diff;
    },
    compareValues: function (value1: unknown, value2: unknown) {
      if (value1 === value2) {
        return this.VALUE_UNCHANGED;
      }
      if (!!value1 === false && !this.isBoolean(value1) && !this.isNumber(value1)) {
        // prev가 falsy 한 값 (boolean, number type 제외)
        return this.VALUE_CREATED;
      }
      if (!!value2 === false && !this.isBoolean(value2) && !this.isNumber(value2)) {
        // next가 truthy 한 값 (boolean, number type 제외)
        return this.VALUE_DELETED;
      }
      return this.VALUE_UPDATED;
    },
    isNumber: function (x: unknown) {
      return typeof x === "number";
    },
    isBoolean: function (x: unknown) {
      return typeof x === "boolean";
    },
    isFunction: function (x: unknown) {
      return Object.prototype.toString.call(x) === "[object Function]";
    },
    isArray: function (x: unknown) {
      return Object.prototype.toString.call(x) === "[object Array]";
    },
    isObject: function (x: unknown) {
      return Object.prototype.toString.call(x) === "[object Object]";
    },
    isValue: function (x: unknown) {
      return !this.isObject(x) && !this.isArray(x);
    },
  };
})();

//웨딩홀 할인율 계산
export const calculateDiscountRate = (
  originalPrice: string | number,
  salePrice: string | number,
) => {
  if (Number(originalPrice) <= 0) {
    return 0; // 원래 가격이 0 이하인 경우 처리
  }
  const discountRate = ((Number(originalPrice) - Number(salePrice)) / Number(originalPrice)) * 100;
  return Number(discountRate.toFixed(0)); // 정수로 반환
};

// 인코딩 버전 기준으로 문자열의 바이트 길이를 계산하는 함수
function getByteLength(str, encoding = "utf-8") {
  let byteLength = 0;
  for (let i = 0; i < str.length; i++) {
    const charCode = str.charCodeAt(i);

    if (encoding === "euc-kr") {
      // EUC-KR 인코딩일 때
      if (charCode <= 0x007f) {
        byteLength += 1; // 영문, 숫자 및 특수문자는 1바이트
      } else {
        byteLength += 2; // 한글 등은 2바이트
      }
    } else {
      // UTF-8 인코딩일 때 (default)
      if (charCode <= 0x007f) {
        byteLength += 1; // 영문, 숫자 및 특수문자는 1바이트
      } else if (charCode <= 0x07ff) {
        byteLength += 2; // 2바이트 문자
      } else {
        byteLength += 3; // 한글 등은 3바이트
      }
    }
  }

  return byteLength;
}

// 30바이트 이하의 난수를 생성 함수
export const generateRandomId = (encoding: "utf-8" | "euc-kr" = "utf-8") => {
  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789"; // 사용할 문자들
  let randomId = "";

  while (getByteLength(randomId, encoding) < 30) {
    const randomChar = chars.charAt(Math.floor(Math.random() * chars.length));
    if (getByteLength(randomId + randomChar) > 30) {
      break; // 30바이트가 넘으면 종료
    }
    randomId += randomChar;
  }

  return randomId;
};

export const encryptAES = (data: string, key: string) => {
  const keyHex = CryptoJS.enc.Utf8.parse(key);
  const encrypted = CryptoJS.AES.encrypt(data, keyHex, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
  return encrypted.toString(); // base64 string
};

export const decryptAES = (encryptedData: string, key: string) => {
  const keyHex = CryptoJS.enc.Utf8.parse(key);
  const decrypted = CryptoJS.AES.decrypt(encryptedData, keyHex, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
  return decrypted.toString(CryptoJS.enc.Utf8);
};
